import images from './images';

let reviews = [
	{
		name: 'Company: MIDAS Labs, IIIT Delhi',
		position: 'position: Web Developer Intern',
		image: images.avatar0,
		review: `During my internship at MIDAS Labs (Oct 2023 - Apr 2024) as a Frontend Developer, I worked on the Audino project, an open-source audio annotation tool. I implemented features for organization management using React, React Query, Zustand, and Docker, and developed advanced UIs for AI-powered tools like text-to-voice and voice-to-text. Additionally, I built a landing page with Astro.js, resulting in faster load times and improved efficiency.`,
	},
	{
		name: 'Company: IDYLL',
		position: 'position: Web Developer Intern',
		image: images.avatar1,
		review: `During my internship at Idyll (Apr 2023 - Sep 2023) as a Full Stack Developer, I designed RESTful APIs and implemented secure authentication mechanisms. I worked on containerization using Docker and automated testing with Jest. Additionally, I integrated Git hooks, comprehensive error handling, and Winston logging, adhering to Test-Driven Development principles to ensure maintainable code.`,
	},

	{
		name: 'Company: N Computing (Rajasthan IT)',
		position: 'position: Part-time Website Developer',
		image: images.avatar3,
		review: `As a part-time Web Developer at RajasthanIT Center, a franchise of NComputing (Jan 2021 - Jun 2021), I designed and developed a modern multi-page landing website to showcase their product line. I deployed the website, optimized it for search engines, and contributed to their online success. Skills: Bootstrap, Web Hosting,godaddy, cloudflare, Hostinger, HTML5, CSS, JavaScript.`,
	},
	{
		name: 'Company: Shri Balaji Dying',
		position: 'position: freelancer',
		image: images.avatar4,
		review: 'As a Freelance Web Developer (Aug 2021 - Oct 2021), I partnered with Shri Balaji Dying to craft a dynamic e-commerce site, enhancing user experience, driving sales, and boosting revenue. My expertise in WordPress, HTML5, CSS, and JavaScript guarantees innovative web solutions.',
	},
];

export { reviews };
